<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p38"><span><a href="#/Contents#rp38">DILLED CARROT SOUP</a></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Carrots team with dill for a fresh, clean flavor.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1½ cups chopped onions</span></p>
<p class="hang"><span>2 cloves garlic, minced</span></p>
<p class="hang"><span>1½ quarts reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>1 can (14½ ounces) reduced-sodium diced tomatoes, undrained</span></p>
<p class="hang"><span>2 pounds carrots, thickly sliced</span></p>
<p class="hang"><span>1 medium Idaho potato, peeled, cubed</span></p>
<p class="hang"><span>1–1½ teaspoons dried dill weed</span></p>
<p class="hang"><span>2–3 tablespoons lemon juice</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>6 tablespoons fat-free plain yogurt</span></p>
<p class="normalt"><span><a id="page_30"></a><b>1.</b> Sauté onions and garlic in lightly greased large saucepan until tender, about 5 minutes. Add broth, tomatoes with liquid, carrots, potato and dill weed; heat to boiling. Reduce heat and simmer, covered, until vegetables are tender, about 15 minutes. Process soup in food processor or blender until smooth; season to taste with lemon juice, salt, and white pepper. Serve soup warm or chilled. Garnish each bowl of soup with a dollop of yogurt.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 139</span></p>
<p class="per1"><span>% calories from fat: 6</span></p>
<p class="per1"><span>Protein (g): 4.4</span></p>
<p class="per1"><span>Carbohydrate (g): 30.5</span></p>
<p class="per1"><span>Fat (g): 1</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0.3</span></p>
<p class="per1"><span>Sodium (mg): 88</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 6.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0220.vue?77fb68ea